import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { Router } from '@angular/router';
import { giantAnimations } from '../admin-layout/animations';
import { GiantConfigService } from '../admin-layout/services/config-service';
import { GetLogin } from 'src/app/models/get-login.model';
import { ConfirmedValidator } from './confirmed-validator';
import { UserRepository } from 'src/app/repositories/user/UserRepository';
import { MatSnackBar } from '@angular/material/snack-bar';
import { GiantSnackBarService } from 'src/app/shared/utils/giant-snack-bar';



@Component({
    selector: 'get-login',
    templateUrl: './get-login.component.html',
    styleUrls: ['./get-login.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: giantAnimations
})
export class GetLoginComponent implements OnInit {
    getLoginModel=new GetLogin();

    constructor(
        private _giantConfigService: GiantConfigService,
        private _userRepository: UserRepository,
        private _router: Router,
        private _giantSnackBarService: GiantSnackBarService
    ) {
        // Configure the layout
        this._giantConfigService.config = {
            layout: {
                navbar: {
                    hidden: true
                },
                toolbar: {
                    hidden: true
                },
                footer: {
                    hidden: true
                },
                sidepanel: {
                    hidden: true
                }
            }
        };
    }

    ngOnInit(): void {
        
    }
  
    onGetLogin(){
        debugger
         this._userRepository.GetLogin(this.getLoginModel).subscribe((res : any) => {

            if (res._obj.response[0].ResponseCode == 100) {
                this._giantSnackBarService.snackbarSuccess(res._obj.response[0].ResponseMessage);
                this._router.navigate(['/login'])
              }
              if (res._obj.response[0].ResponseCode == 101) {
                this._giantSnackBarService.snackbarError(res._obj.response[0].ResponseMessage);
              }
        });
    }
}
